var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconNavyBlueLightGrayBgRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5542_3266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 29.5,
    transform: "rotate(90 34 30)",
    fill: "white",
    stroke: "#5062F0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5542_3266",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8284 24H44.0188V40.0002C44.0188 41.1047 43.1234 42.0002 42.0188 42.0002H25.8284C24.7238 42.0002 23.8284 41.1047 23.8284 40.0002V24Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.8284 24H44.0188V40.0002C44.0188 41.1047 43.1234 42.0002 42.0188 42.0002H25.8284C24.7238 42.0002 23.8284 41.1047 23.8284 40.0002V24Z",
    fill: "#010311",
    stroke: "#010311",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1_5542_3266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19.5H46V22.5H22V19.5Z",
    fill: "#010311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1955 18.4783C28.3771 18.1812 28.7003 18 29.0486 18H38.7991C39.1474 18 39.4705 18.1812 39.6522 18.4783L40.9905 20.6667H26.8572L28.1955 18.4783Z",
    fill: "#010311"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5052,
    height: 3.37724,
    transform: "matrix(0.708752 -0.705458 0.718986 0.695024 28 36.5908)",
    fill: "#F2B90D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5004,
    height: 3.37842,
    transform: "matrix(-0.695805 -0.718231 0.731492 -0.68185 37.4617 39)",
    fill: "#F2B90D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5542_3266",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5542_3266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5542_3266",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconNavyBlueLightGrayBgRounded);
export default __webpack_public_path__ + "static/media/trashIconNavyBlueLightGrayBgRounded.90902dec97c245318c7af60accb9409c.svg";
export { ForwardRef as ReactComponent };